// extracted by mini-css-extract-plugin
export default {"wrapper":"AddProduct_wrapper__HLG9T"};